import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
// Import Routes all
import { authProtectedRoutes, commonFullPageRouters, publicRoutes, authProtectedRoutesAdmin } from "./routes";

// layouts Format
import NonAuthLayout from "./components/NonAuthLayout";

import { useMediaQuery } from 'react-responsive';
// Import scss
import Authmiddleware from "_guard/Authmiddleware";
import Forbidden403 from "components/Forbidden403";
import CustomerDashboard from "pages/dashboard/customer";
import "./assets/scss/theme.scss";
import VerticalLayout from "components/VerticalLayout";
import HorizontalLayout from "components/HorizontalLayout";
import { decryptedValue, uId } from "common/utility";

const App = () => {
  const navigate = useNavigate();
  const publicArray = ["/logout", "/login", "/inquiry", "/customer/register", "/customer/register-otp-verify", "/reset-password", "/forget-password", "/mobile-otp-verify","/reset-password/", "/internal-login", "/validate-login","/validate-login/"]
  const [protectedRoutes, setProtectedRoutes] = useState([])

  useEffect(() => {
    const currentPath = location.pathname;
    const user = decryptedValue(localStorage.getItem("user"));
    const isLoggedIn = JSON.parse(localStorage.getItem("isLoggedIn"))
    
    if (user) {
       if(user.roleName === "financier_admin" || user.roleName === "financier_operations" || user.roleName === "fundLync_cutomer") {
        setProtectedRoutes(authProtectedRoutes)
      }
      else{
        setProtectedRoutes(authProtectedRoutesAdmin(user.roleName))
      }
      
    } 
    else if (!isLoggedIn && !publicArray.includes(currentPath)) {
      if (window.location.href.includes('fundlyncuat') || window.location.href.includes('fundlync') || window.location.href.includes('localhost')) {
        navigate("/login");
      } else if (!publicArray.includes(currentPath)) {
        navigate("/internal-login");
      }
    } else {
      setProtectedRoutes([])
      // navigate("/login")
    }
    const handleUnauthorizedEvent = () => {
      navigate("/login");
    };
    const handleForbiddenEvent = () => {
      navigate("/forbidden-zone")
    }

    window.addEventListener("unauthorized", handleUnauthorizedEvent);
   window.addEventListener("forbidden", handleForbiddenEvent);

    return () => {
      window.removeEventListener("unauthorized", handleUnauthorizedEvent);
      window.removeEventListener("forbidden", handleForbiddenEvent);
    };
  }, [navigate]);
  const isMobileOrTablet = useMediaQuery({ query: '(max-width: 1024px)' });
  return (
    <React.Fragment>
      <Routes>
        {publicRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={<NonAuthLayout>{route.component}</NonAuthLayout>}
            key={`p-${uId()}-${route.path}`}
            exact={true}
          />
        ))}
        {protectedRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <Authmiddleware route={route}>
                {isMobileOrTablet ? (
                  <HorizontalLayout>{route.component}</HorizontalLayout>
                ) : (
                  <VerticalLayout>{route.component}</VerticalLayout>
                )}
              </Authmiddleware>
            }
            key={`a-${uId()}-${route.path}`}
            exact={true}
          />
        ))}

        {commonFullPageRouters.map((route, idx) => (
          <Route
            path={route.path}
            element={<NonAuthLayout>{route.component}</NonAuthLayout>}
            key={`c-${uId()}-${route.path}`}
            exact={true}
          />
        ))}

        <Route path="/" component={CustomerDashboard} />
        <Route path="/forbidden-zone" element={<Forbidden403 />} />
      </Routes>
    </React.Fragment>
  );
};

App.propTypes = {
  layout: PropTypes.any,
};

export default App;
